module.exports = __webpack_public_path__ + "uml.195618b4dccba5a6eb96.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/uml.png
// module id = ../../../../../src/assets/images/uml.png
// module chunks = main